const _excluded = ["className", "value", "valueKey", "labelKey", "allowCreate", "returnValueKey", "onChange", "options"],
  _excluded2 = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import PropTypes from 'prop-types';
import React from 'react';
import Select from './select';
const SinglePicker = _ref => {
  let {
      className = '',
      value = '',
      valueKey = 'id',
      labelKey = 'name',
      allowCreate = false,
      returnValueKey = null,
      onChange,
      options = null
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const handleChange = incomingValue => {
    /* eslint-disable-next-line no-underscore-dangle */
    const isOtherValue = (incomingValue || {}).__isNew__;
    let val = null;
    const extractKey = allowCreate && returnValueKey && isOtherValue ? labelKey : returnValueKey;
    if (returnValueKey && incomingValue) {
      val = incomingValue[extractKey];
    } else if (incomingValue) {
      /**
       * Remove className but pass the rest back to onChange.  Some portions of
       * our application relies on more then just the data at labelKey and valueKey
       */
      const _JSON$parse = JSON.parse(JSON.stringify(incomingValue)),
        {
          className: _
        } = _JSON$parse,
        rest = _objectWithoutProperties(_JSON$parse, _excluded2);
      val = rest;
    }
    onChange(val);
  };
  const prepareValue = () => {
    let result = value;
    if (value !== null && typeof result === 'object') {
      result = result[valueKey];
    }
    return result;
  };
  const selectProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    values: prepareValue(),
    multi: false,
    allowCreate,
    onChange: handleChange,
    className: `${className} t-sp`,
    value,
    valueKey,
    labelKey,
    returnValueKey,
    options
  });
  return /*#__PURE__*/React.createElement(Select, selectProps);
};
SinglePicker.propTypes = {
  className: PropTypes.string,
  labelKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  valueKey: PropTypes.string,
  returnValueKey: PropTypes.string,
  allowCreate: PropTypes.bool,
  disabled: PropTypes.bool,
  verticalPadding: PropTypes.bool
};
export default SinglePicker;